import * as React from 'react';
import { Alert, Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { ReportAlias } from '../../../types/ReportAlias/ReportAlias';
import { Dispatch } from 'redux';
import axios, { AxiosError } from 'axios';
import { DashboardAlias } from '../../../types/DashboardAlias/DashboardAlias';
import { IPowerBiReportViewerObject } from '../../../types/Common/IPowerBiReportViewerObject';
import { PowerBiObjectType } from '../../../types/Common/PowerBiObjectType';

type AddAliasModalProps = {
    dispatch: Dispatch;
    powerBiObject: IPowerBiReportViewerObject;
    addAlias: any;
    hideModal: any;
    showModal: boolean;
    isAddAliasMode: boolean;
    reportAlias: ReportAlias | undefined;
}

interface AddAliasModalState {
    isLoaded: boolean;
    validated: boolean;
    aliasId: string;
    aliasName: string;
    isDefault: boolean;
    isHidden: boolean;
    hasError: boolean;
    errorMessage: string;
}

class AddAliasModal extends React.Component<AddAliasModalProps, AddAliasModalState> {
    public constructor(props: AddAliasModalProps) {
        super(props);
        this.state = {
            isLoaded: false,
            validated: false,
            aliasId: '',
            aliasName: '',
            isDefault: false,
            isHidden: false,
            hasError: false,
            errorMessage: '',
        }
    }

    private setupEditState() {
        if (this.props.isAddAliasMode === false && this.props.reportAlias) {
            this.setState({
                aliasId: this.props.reportAlias.id,
                aliasName: this.props.reportAlias.aliasName,
                isDefault: this.props.reportAlias.isDefault,
                isHidden: this.props.reportAlias.isHidden,
            });
        }
    }

    // Reset the modal state to default
    private resetState() {
        this.setState({
            aliasId: this.props.powerBiObject.id,
            aliasName: "",
            isDefault: false,
            isHidden: false,
            errorMessage: "",
            hasError: false,
        });
        this.setState({validated: false});
    }

    private handleCloseModal() {
            this.props.hideModal();
            this.resetState();
    }

    private handleSubmit(e: React.FormEvent<HTMLInputElement>){
        e.preventDefault();
        e.stopPropagation();

        const form = e.currentTarget;

        if (this.props.powerBiObject.type === PowerBiObjectType.Dashboard) {

            let aliasDto = {} as DashboardAlias;
            aliasDto.id = this.state.aliasId ? this.state.aliasId : "00000000-0000-0000-0000-000000000000"
            aliasDto.dashboardId = this.props.powerBiObject.id;
            aliasDto.aliasName = this.state.aliasName;
            aliasDto.isDefault = this.state.isDefault;
            aliasDto.isHidden = this.state.isHidden;

            if (this.props.isAddAliasMode) {
                this.requestAddDashboardAlias(this.props.powerBiObject.id, aliasDto);
            }
            else {
                this.requestUpdateDashboardAlias(this.props.powerBiObject.id, aliasDto);
            }
         }
         else if (this.props.powerBiObject.type === PowerBiObjectType.Report) {

            let aliasDto = {} as ReportAlias;
            aliasDto.id = this.state.aliasId ? this.state.aliasId : "00000000-0000-0000-0000-000000000000"
            aliasDto.reportId = this.props.powerBiObject.id;
            aliasDto.aliasName = this.state.aliasName;
            aliasDto.isDefault = this.state.isDefault;
            aliasDto.isHidden = this.state.isHidden;

            if (this.props.isAddAliasMode) {
                this.requestAddReportdAlias(this.props.powerBiObject.id, aliasDto);
            }
            else {
                this.requestUpdateReportAlias(this.props.powerBiObject.id, aliasDto);
            }
         }

    }

    private requestAddDashboardAlias(dashboardId: string, aliasDto: DashboardAlias) {
        axios
        .post<DashboardAlias>(`./api/dashboards/${dashboardId}/aliases`, aliasDto, { timeout: 30000 })
        .then((response: { data: DashboardAlias; }) => {
            const { data } = response;
                this.props.addAlias();
                this.handleCloseModal();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;

            this.setState({validated: false}); 
            this.setState({errorMessage: errorMessage});
            this.setState({hasError: true});
        });
    }
 
    private requestUpdateDashboardAlias(dashboardId: string, aliasDto: DashboardAlias) {

        axios
        .patch<DashboardAlias>(`./api/dashboards/${dashboardId}/aliases/${aliasDto.id}`, aliasDto, { timeout: 30000 })
        .then((response: { data: DashboardAlias; }) => {
            const { data } = response;
                this.props.addAlias();
                this.handleCloseModal();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;
            this.setState({validated: false}); 
            this.setState({errorMessage: errorMessage});
            this.setState({hasError: true});
        });
    }

    private requestAddReportdAlias(reportId: string, aliasDto: ReportAlias) {
        axios
        .post<ReportAlias>(`./api/reports/${reportId}/aliases`, aliasDto, { timeout: 30000 })
        .then((response: { data: ReportAlias; }) => {
            const { data } = response;
                this.props.addAlias();
                this.handleCloseModal();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;

            this.setState({validated: false}); 
            this.setState({errorMessage: errorMessage});
            this.setState({hasError: true});
        });
    }
 
    private requestUpdateReportAlias(reportId: string, aliasDto: ReportAlias) {

        axios
        .patch<ReportAlias>(`./api/reports/${reportId}/aliases/${aliasDto.id}`, aliasDto, { timeout: 30000 })
        .then((response: { data: ReportAlias; }) => {
            const { data } = response;
                this.props.addAlias();
                this.handleCloseModal();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;
            this.setState({validated: false}); 
            this.setState({errorMessage: errorMessage});
            this.setState({hasError: true});
        });
    }

    public render() {

        const updateAliasNameValue = (event: React.ChangeEvent<HTMLInputElement>) => {
            this.setState({aliasName: event.target.value});
        }

        const updateIsDefaultValue = (event: React.ChangeEvent<HTMLInputElement>) => {
            this.setState({isDefault: event.target.checked});
        }

        const updateIsHiddenValue = (event: React.ChangeEvent<HTMLInputElement>) => {
            this.setState({isHidden: event.target.checked});
        }

        return(
            <Modal size="lg" show={this.props.showModal} onShow={() => this.setupEditState()} onHide={() => this.handleCloseModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.props.isAddAliasMode ? "Add Alias" : "Edit Alias"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Container>
                <Row>
                    <Col>
                        <Alert variant='danger' show={this.state.hasError ? true : false}>
                            {this.state.errorMessage}
                        </Alert>
                    </Col>
                </Row>
                        <Form
                            noValidate 
                            validated={this.state.validated} 
                            onSubmit={(e: React.FormEvent<any>) => this.handleSubmit(e)}
                        >
                            <Form.Group as={Row} controlId="aliasName">
                                <Form.Label column md={2} className="fw-bold">
                                    Alias Name
                                </Form.Label>
                                <Col md={10}>
                                    <Form.Control 
                                    placeholder={"Enter alias name (no ascii characters)"}
                                    aria-label="Alias Name"
                                    aria-describedby='aliasName'
                                    onChange={updateAliasNameValue}
                                    value={this.state.aliasName}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="isDefault">
                                <Form.Label column md={2} className="fw-bold">
                                    Is Default?
                                </Form.Label>
                                <Col md={10}>
                                    <Form.Check type="checkbox" 
                                    onChange={updateIsDefaultValue}
                                    checked={this.state.isDefault}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group className="mb-3" as={Row} controlId="isHidden">
                                <Form.Label column md={2} className="fw-bold">
                                    Is Hidden?
                                </Form.Label>
                                <Col md={10}>
                                    <Form.Check type="checkbox" 
                                    onChange={updateIsHiddenValue}
                                    checked={this.state.isHidden}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} controlId="submit-btn">
                                <Col className="text-end">
                                    <Button variant="secondary" className="ms-3" type="submit">{this.props.isAddAliasMode ? "Add Alias" : "Edit Alias"}</Button>
                                    <Button variant="danger" className="ms-3" onClick={() => this.handleCloseModal()}>Cancel</Button>
                                </Col>
                            </Form.Group>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );
    }
}

export default AddAliasModal;